export const newPartRequest = {
  label: 'pages.partRequest.newPartRequest',
  icon: "pencil-plus",
  link: 'part-request/new',
}
export const partRequestList = {
  label: 'pages.partRequest.partRequestList',
  icon: "view-list-outline",
  link: 'part-request/list',
}

export const newRemoteSupport = {
  label: 'pages.remoteSupport.newRemoteSupport',
  icon: "message-plus-outline",
  link: 'remote-support/new',
}
export const remoteSupportList = {
  label: 'pages.remoteSupport.remoteSupportList',
  icon: "message-bulleted",
  link: 'remote-support/list',
}

export const newRepair = {
  label: 'pages.repair.newRepair',
  icon: 'package-variant-closed-plus',
  link: 'new-repair',
}
export const actionRequired = {
  label: 'pages.repair.actionRequired',
  icon: 'account-alert',
  link: 'action-required',
  notificationCount: null
}
export const activeRepairs = {
  label: 'pages.repair.activeRepairs',
  icon: 'playlist-edit',
  link: 'active-repairs',
}
export const closedRepair = {
  label: 'pages.repair.closedRepair',
  icon: 'playlist-check',
  link: 'closed-repairs',
}
export const generalReport = {
  label: 'pages.repair.generalReport',
  icon: 'chart-pie',
  link: 'reports/general',
}